export function clearUserDetailsWindow() {
  return {
    type: 'CLEAR_USER_DETAILS_WINDOW'
  }
}

export function initUserDetailsWindow() {
  return {
    type: 'INIT_USER_DETAILS_WINDOW'
  }
}
